import React from 'react';
import styles from './List.module.scss';
import ListItem from './ListItem/ListItem';
import Element, { CommonProps } from '../Element/Element';
import { ArrayElementType } from '../../types/utils/ArrayElementType';

const supportedListTags = ['ul', 'ol'] as const;
type supportedListTag = ArrayElementType<typeof supportedListTags>;

export type ListProps = {
  /** Unordered or ordered list */
  numbered?: boolean;
  /** List item with disc */
  disc?: boolean;
  tagName?: supportedListTag;
} & CommonProps<'ol'>;
// Aliases for backwards compatibility
export type ListAttributes = ListProps;

const List: React.FunctionComponent<ListProps> & {
  Item: typeof ListItem;
} = ({ className, numbered, children, tagName, disc, ...props }) => {
  const TagName = numbered ? 'ol' : 'ul';

  const classNames = [
    styles.list,
    {
      [styles.list__ol]: numbered,
      [styles.list__ul]: !numbered,
      [styles.list__disc]: disc,
    },
  ];

  if (!!className) {
    classNames.push(className as string);
  }

  return (
    <Element tagName={tagName || TagName} className={classNames} {...props}>
      {children}
    </Element>
  );
};

List.Item = ListItem;

export default List;
